<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">
        <template v-if="auxiliary">{{ auxiliary.name }}</template>
        <template v-if="auxiliaryItem">:{{ auxiliaryItem.name }}</template>
        多栏账
      </span>
    </div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <account-date-choose v-model="accountDate" />
      </Cell>
      <Cell></Cell>
      <Cell :flex="1"></Cell>
    </Row>
    <Row class="h-panel-body" type="flex" :space-x="10">
      <Cell :flex="1">
        <Table
            :datas="dataList"
            :border="true"
            :loading="loading"
            class="table"
        >
          <TableItem title="日期" prop="voucherDate" :width="150"></TableItem>
          <TableItem title="凭证字号" :width="150">
            <!-- v-if移到router-link，修复slot-scope语法错误 -->
            <template slot-scope="{ data }">
              <router-link
                  v-if="data.word && data.voucherId"
                  :to="{ name: 'VoucherForm', params: { voucherId: data.voucherId } }"
              >
                {{ data.word }}-{{ data.code }}
              </router-link>
            </template>
          </TableItem>
          <TableItem title="科目" prop="subjectName" :width="150"></TableItem>
          <TableItem title="摘要" prop="summary"></TableItem>
          <TableItem title="借方" align="right" :width="150">
            <template slot-scope="{ data }">
              {{ data.debitAmount | numFormat }}
            </template>
          </TableItem>
          <TableItem title="贷方" align="right" :width="150">
            <template slot-scope="{ data }">
              {{ data.creditAmount | numFormat }}
            </template>
          </TableItem>
          <TableItem title="方向" prop="balanceDirection" align="center" :width="150"></TableItem>
          <TableItem title="余额" align="right" :width="150" :title="dynamicTitle">
            <template slot-scope="{ data }">
              {{ data.balance | numFormat }}
            </template>
          </TableItem>
        </Table>
      </Cell>
      <Cell v-width="200">
        <Tree
            @select="doSelect"
            :option="param"
            ref="auxiliary"
            filterable
            selectOnClick
            className="h-tree-theme-row-selected"
        ></Tree>
      </Cell>
    </Row>
  </app-content>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "MultipleColumns",
  data() {
    return {
      dynamicTitle: "借方",
      dataList: [],
      loading: false,
      showNumPrice: false,
      numPriceDisabled: true, // 补充缺失变量
      subject: null, // 补充缺失变量
      subjectId: null, // 补充缺失变量
      param: {
        keyName: "id",
        parentName: "parentId",
        titleName: "name",
        dataMode: "list",
        datas: []
      },
      accountDate: null,
      auxiliary: null,
      auxiliaryItem: null,
      auxiliaryType: [],
      requestLock: false // 防重复请求锁
    };
  },
  watch: {
    subject(newVal, oldVal) {
      const org = this.showNumPrice;
      if (newVal && newVal.unit) {
        this.numPriceDisabled = false;
        this.showNumPrice = true;
      } else {
        this.showNumPrice = false;
      }
      // 仅展示数量价格切换时才重查
      if (org !== this.showNumPrice) {
        this.loadList();
      }
    },
    showNumPrice() {
      // 有选中科目才加载明细
      if (this.subjectId) this.loadList();
    },
    accountDate(newVal, oldVal) {
      // 初始化赋值不触发加载，仅手动修改日期才重载科目树
      if (newVal && oldVal && newVal !== oldVal) {
        this.loadSubject();
      }
    }
  },
  computed: {
    ...mapState(["User", "currentAccountSets"]),
    date() {
      return this.accountDate ? moment(this.accountDate) : moment();
    }
  },
  methods: {
    // 树节点选中回调
    doSelect(node) {
      this.subjectSelect(node);
    },
    subjectSelect(node) {
      this.subject = node;
      this.subjectId = node.id;
      this.loadList();
    },
    updateTitle(newTitle) {
      this.dynamicTitle = newTitle;
    },
    // 加载科目树
    loadSubject() {
      if (this.requestLock) return;
      this.requestLock = true;
      this.dataList = [];
      this.$api.accountbook
          .loadSubject({ accountDate: this.accountDate })
          .then(({ data }) => {
            this.$set(this.param, "datas", data);
            // 默认选中第一个科目
            if (data.length) {
              this.subjectId = data[0].id;
              this.subject = data[0];
              this.loadList();
            } else {
              this.subjectId = null;
              this.subject = null;
            }
          })
          .catch((err) => {
            console.error("加载科目树失败：", err);
          })
          .finally(() => {
            this.requestLock = false;
          });
    },
    // 加载多栏账明细
    loadList() {
      // 无科目ID直接终止请求
      if (!this.subjectId || this.requestLock) return;
      this.requestLock = true;
      this.loading = true;
      this.$api.accountbook
          .loadMultiColDetails({
            accountDate: this.accountDate,
            subjectId: this.subjectId,
            showNumPrice: this.showNumPrice,
            subjectCode: this.subject.code
          })
          .then(({ data }) => {
            this.dataList = data;
          })
          .catch((err) => {
            console.error("加载多栏账明细失败：", err);
          })
          .finally(() => {
            this.loading = false;
            this.requestLock = false;
          });
    },
    doSearch() {
      this.loadAuxiliaryList();
    },
    // 补全缺失方法，避免调用报错
    loadAuxiliaryList() {}
  },
  created() {
    // 初始化账套日期，自动加载科目树
    this.accountDate = this.currentAccountSets.currentAccountDate;
    this.loadSubject();
  }
};
</script>

<style scoped>
/* deep穿透表格样式，解决scoped样式失效 */
/deep/ .table {
  width: 100%;
  overflow-x: auto;
}
</style>